export const DOCUSIGN_CALLBACK = '/tamarisk-document-docusign-callback';
export const DOCUSIGN_DONE = 'tamarisk-document-docusign-done';
export const DOCUSIGN_INCOMPLETE = 'tamarisk-document-docusign-incomplete';
export const APPRAISAL_PAYMENT_LOAN = 'Appraisal_Loan';
export const APPRAISAL_PAYMENT_STANDALONE = 'Appraisal_Standalone';